import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100%;
`;
